import ServiceBase from "base/baseService"

export default class RegimeBaseCalculoService extends ServiceBase {

    title = "Regime de base de cálculo"
    pluralTitle = "Regimes de base de cálculo"
    url = '/cadastro/fiscal/regimebasecalculo'
    frontUrl = '/cadastro/fiscal/regimebasecalculo'
    frontUrlList = '/cadastro/fiscal/regimebasecalculolist'
    primaryKey = 'codigo_regbc'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Strings notNullable

        data.descricao_regbc = data?.descricao_regbc || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
